import Header from "../../../../Shared-Component/Header/Header";
import Footer from "../../../../Shared-Component/Footer/Footer";
import { useState } from 'react';
import CampusSlashTitle from '../../CampusTitles/CampusSlashTitle/CampusSlashTitle';
import CampusHover from "../../CampusHover/CampusHover";
import { Link } from 'react-router-dom';
import "../../CampusViewMore/CampusViewMore.scss"
import "../CampusSkillEnhanceDynamicPage/CampusSkillEnhance.scss"




const CampusSkillEnhanceDynamic = ({ data, content ,twoHoverContent,threeHoverContent}) => {

     const [showContent, setShowContent] = useState(false)
      const [hideContent, setHideContent] = useState(false)
    
       
    
    
      const handleShowContent = () => {
        setShowContent(!showContent);
        setHideContent(!hideContent)
      }
    
    
  return (
    <>
     <div>
        <Header />
        <div className='campusmaincontainer' style={{paddingTop:data.name === "ICT Academy of Tamil Nadu" && 0}}> 
        <div className='campus-container'>
          <CampusSlashTitle slashTitle={data.name} />
          <div className='skill-content-container'>
            {
              (data.para) && <>
                <p>
                  {data.para}
                  {data.viewmore && <span className='campus-viewmore'><Link onClick={handleShowContent}>{!showContent && "View More"}</Link></span>}
                </p>
              </>
            }
            {
              (data.points) && <>
                <ul className='ICT-points-container'>
                  {
                    data.points.map((item, index) =>
                      <li><span>{item.title}</span>{item.content}</li>)
                  }
                </ul>
              </>
            }
            {showContent && (
              <div>
                {data.contentImg && (
                  <div className='institution-innovation-content-img-container'>
                    <img src={data.contentImg} alt="Content" />
                  </div>
                )}

                {data.contentparaTitle && data.contentpara && (
                  <div className='institution-innovation-content-para-container'>
                    <h2>{data.contentparaTitle}</h2>
                    <p>{data.contentpara}
                       {
                        data.viewless &&
                        (
                          <span className='campus-viewmore'>
                            <Link onClick={handleShowContent} >
                              {hideContent && "View Less"}
                            </Link>
                          </span>
                        )
                      }
                    </p>
                  </div>
                )}
              </div>
            )}

          </div>
        <CampusHover title={data} content={content} />
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default CampusSkillEnhanceDynamic